import compose from './compose';
import context from './context';
import runtime from './runtime';

import GLOBAL from '../util/global';
import { mergeIgnoreList, getPageId } from '../util/utils';

import DejavuMiddleware from '../middleware/dejavu-middleware';
import AjaxMiddleware from '../middleware/ajax-middleware';
import EventMiddleware from '../middleware/event-middleware';
import HijackMiddleware from '../middleware/hijack-middleware';
import JSMiddleware from '../middleware/js-middleware';
import PDMiddleware from '../middleware/pd-middleware';
import PVMiddleware from '../middleware/pv-middleware';
import ReportMiddleware from '../middleware/report-middleware';
import ResourceMiddleware from '../middleware/resource-middleware';

import { EventEmitter2 } from 'eventemitter2';
import { InitOption } from './types/core.type';

class Core extends EventEmitter2 {

    public pageId: string = '';
    public pageUrl: string = GLOBAL.location.href;
    public channel: string = null;
    public ignore: any = { xhr: [], resource: [] };

    private middleware: any[];
    private context: any;
    private runtime: any;

    constructor(opt?: any) {
        super();

        this.middleware = [];
        this.context = Object.create(context);
        this.runtime = Object.create(runtime);

        if (opt) {
            this.pageId = opt.pageId || this.pageId;
            this.pageUrl = opt.pageUrl || this.pageUrl;
            this.channel = opt.channel || this.channel;
            this.ignore = opt.ignore || this.ignore;
        }
        if (this.runtime.autopv) {
            this.pageId = getPageId(this.pageId);
        }
        this.ignore = mergeIgnoreList(this.ignore);
        this.start();
    }

    public set(opt: InitOption): Core {
        // Set prajna configurations;
        this.pageId = opt.pageId || this.pageId;
        this.pageUrl = opt.pageUrl || this.pageUrl;
        this.channel = opt.channel || this.channel;
        if (opt.ignore) {
            this.ignore = mergeIgnoreList(opt.ignore);
        }
        return this;
    }

    public use(lambda: (...args: any[]) => any): Core {
        // Install prajna middleware
        this.middleware.push(lambda);

        return this;
    }

    private start(): Core {
        this.use(DejavuMiddleware)
            .use(PVMiddleware)
            .use(ResourceMiddleware)
            .use(AjaxMiddleware)
            .use(HijackMiddleware)
            .use(EventMiddleware)
            .use(JSMiddleware)
            .use(ReportMiddleware)
            .use(PDMiddleware);

        this.on('BEAT_EVENT', this.callback());

        this.beat(); // beat once when start

        return;
    }

    private beat(): Core {
        this.emit('BEAT_EVENT');

        return this;
    }

    private callback(): () => any { // TODO
        const lambda: (ctx: any, next?: any) => any = compose(this.middleware);
        const handler = () => {
            const ctx = this.createContext();
            return lambda(ctx).then().catch((err: Error) => {
                console.log(err); // eslint-disable-line
            });
        };

        return handler;
    }

    private createContext(): void {
        const ctx = Object.create(this.context);
        const rt = ctx.runtime = Object.create(this.runtime);

        ctx.core = rt.core = this;

        return ctx; // { runtime: { core: { this }, }, core: { this }, }
    }
}

export default Core;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/core.ts